/* eslint-disable @typescript-eslint/no-explicit-any */
import { render, h } from "vue";
import getPrivateKeyVue from "./getPrivateKey.vue";
import { getUserInfo } from "@/api/login";
import { useStore } from "@/store";
import { getKeyChain } from "@/utils/hooks/systemKeychain";

const IS_ELECTRON = process.env.IS_ELECTRON;

export const getPrivateKey = async (
  resetPassword?: boolean,
  color = "#4749ad"
) => {
  const res = await getUserInfo();
  const store = useStore() as any;
  store.commit("user/setUserInfo", res);
  const userNo = res.userNo;
  if (IS_ELECTRON) {
    const keyChain = await getKeyChain(userNo);
    if (keyChain) {
      log.info("keychain exists, returning private key", keyChain !== null);
      return Promise.resolve(keyChain.privateKey);
    }
  }

  return new Promise<string>((resolve, reject) => {
    const container = document.createElement("div");
    render(
      h(getPrivateKeyVue, {
        resetPassword: resetPassword || false,
        color,
        onClose: () => {
          render(null, container);
          container.remove();
          reject();
        },
        onScrect: (privatekey: string) => {
          render(null, container);
          container.remove();
          log.info("privatekey success");
          resolve(privatekey);
        },
      }),
      container
    );
    document.body.appendChild(container);
  });
};
